// MCP broker integration is not yet available to users; the box stays visible
// as a preview of what's coming but is fully non-interactive.
const MCP_FEATURE_ENABLED = false;

const McpSetup = () => {
  if (!MCP_FEATURE_ENABLED) {
    return (
      <div className="bg-slate-800/30 border border-slate-700/30 rounded-xl p-6 opacity-60 grayscale select-none">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-slate-700/30 flex items-center justify-center text-xl">🔌</div>
          <div>
            <h3 className="text-slate-400 font-semibold">MCP Broker Connection</h3>
            <p className="text-xs text-slate-500">Connect your broker&apos;s MCP server for live data + assisted execution</p>
          </div>
          <span className="ml-auto text-xs bg-slate-700/50 text-slate-400 px-2 py-0.5 rounded font-medium">
            Coming Soon
          </span>
        </div>

        <fieldset disabled className="space-y-4 pointer-events-none">
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">MCP Server URL</label>
            <input
              type="url"
              value=""
              readOnly
              placeholder="https://mcp.yourbroke.com/v1"
              className="w-full bg-slate-700/40 border border-slate-600/50 text-slate-500 rounded-lg px-3 py-2 text-sm cursor-not-allowed"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Auth Token <span className="text-slate-600">(optional)</span>
            </label>
            <input
              type="password"
              value=""
              readOnly
              placeholder="Bearer token or API key"
              className="w-full bg-slate-700/40 border border-slate-600/50 text-slate-500 rounded-lg px-3 py-2 text-sm cursor-not-allowed"
            />
          </div>
          <button
            type="button"
            disabled
            className="w-full py-2 bg-slate-700/50 text-slate-500 rounded-lg text-sm font-medium cursor-not-allowed"
          >
            Not Available Yet
          </button>
        </fieldset>
      </div>
    );
  }

  return null;
};

export default McpSetup;
